<template>
  <div class="month-multiple-picker d-flex align-center" style="width: 100%">
    <div style="width: 100%">
      <v-menu
        ref="targetDate"
        v-model="pickerFlag"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-row no-gutters v-on="on">
            <v-combobox
              class="picker-combobox"
              v-model="dateFormatted"
              multiple
              chips
              label="対象年月"
              readonly
              color="primary"
            ></v-combobox>
          </v-row>
        </template>
        <v-date-picker
          v-model="date"
          locale="ja"
          no-title
          type="month"
          multiple
        ></v-date-picker>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
    disabled: Boolean,
    label: { default: "対象年月", type: String },
  },
  data: (vm) => ({ pickerFlag: false, formattingDate: vm.value }),
  computed: {
    date: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.formattingDate = newValue;
        this.$emit("input", newValue);
      },
    },
    dateFormatted: {
      get() {
        if (!this.date) return null;
        const formatDates = [];
        for (const ele of this.date) {
          const [year, month] = ele.split("-");
          formatDates.push(`${year}年${month}月`);
        }
        return formatDates;
      },
    },
  },
  watch: {
    pickerFlag() {
      if (!this.pickerFlag) {
        this.$emit("blur", this.date);
      }
    },
  },
};
</script>

<style lang="scss">
.date-chip-area {
  width: 100%;
  border-color: rgba(0, 0, 0, 0.42) !important;
  border-style: solid;
  border-width: thin 0 0 0;
}

.month-multiple-picker {
  .picker-combobox {
    .v-chip {
      background: #42ba97;
      color: white;
      opacity: 1;
    }
  }
}
</style>